<template>
  <v-row>
    <v-col cols="12" class="px-0">
      <v-toolbar color="transparent" flat height="55">
        <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
          Análisis
          <piriod-beta-label element="Chip" feature="Receivables" />
        </v-toolbar-title>
      </v-toolbar>
    </v-col>

    <!-- billed and how much of it was collected -->
    <v-col cols="4">
      <metric-kpi metric="total_billing" interval="monthly" comparative="this_v_last_mtd" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="collection_rate" interval="monthly" comparative="this_v_last_mtd" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="days_sales_outstanding" interval="monthly" />
    </v-col>
    <!-- end billed and how much of it was collected -->

    <v-col cols="4">
      <receivables-summary-card />
    </v-col>
    <v-col cols="8">
      <metric-graph metric="document_status_breakdown" />
    </v-col>
    <v-col cols="6">
      <metric-table metric="overdue_billing_recovery_breakdown" />
    </v-col>
    <v-col cols="6">
      <metric-table metric="customer_debtor" />
    </v-col>
  </v-row>
</template>
<script>
import MetricGraph from '@/components/reports/MetricGraph'
import MetricKpi from '@/components/reports/MetricKpi'
import MetricTable from '@/components/reports/MetricTable'
import PiriodBetaLabel from '@/components/ux/PiriodBetaLabel'
import ReceivablesSummaryCard from '@/components/reports/ReceivablesSummaryCard'

export default {
  components: {
    MetricGraph,
    MetricKpi,
    MetricTable,
    PiriodBetaLabel,
    ReceivablesSummaryCard
  }
}
</script>
